module.exports = __webpack_public_path__ + "static/media/calefaccion electrica publico y comercial.7ab285ce.jpg";